export const APP_ENV = {
  LOCAL: 'local',
  DEVELOPMENT: 'development',
  STAGING: 'staging',
  PRODUCTION: 'production',
};

export const getEnvironment = () => {
  const url = document.location.host;
  let environment = process.env.REACT_APP_ENVIRONMENT;

  if (url.includes('localhost')) {
    environment = APP_ENV.LOCAL;
  } else if (url.includes('develop') || url.includes('dev')) {
    environment = APP_ENV.DEVELOPMENT;
  } else if (url.includes('staging') || url.includes('stg')) {
    environment = APP_ENV.STAGING;
  } else {
    environment = APP_ENV.PRODUCTION;
  }

  return environment;
};

export const getUrl = (sitePrefix) => {
  let envSuffix = '-dev';
  const env = getEnvironment();

  if (env === APP_ENV.STAGING) {
    envSuffix = '-stg';
  } else if (env === APP_ENV.PRODUCTION) {
    envSuffix = '';
  }

  return `https://${sitePrefix}${envSuffix}.nationsafedrivers.com`;
}